// extracted by mini-css-extract-plugin
module.exports = {"container":"Environment__container___3IDA6","main":"Environment__main___iBW8s","content":"Environment__content___vGiLI"};